<template>
<div>
  <imageLoader :small-image-url="banners[0].smallUrl" :big-image-url="banners[0].url" 
            class="banner mb-5"> </imageLoader>

  <div id="margot-title" class="d-flex flex-column align-items-center margot-block appearing-item">
    <img src="../assets/Margot.png" class="margot-image">
    <div class="margot-subtext">&bull; kleurenkunstenares &bull;</div>
  </div>

  <imageLoader :small-image-url="banners[1].smallUrl" :big-image-url="banners[1].url" 
            class="banner my-5"> </imageLoader>
  
  <div id="about" class="row appearing-item">
    <div class="col-md-6 d-flex justify-content-center align-self-center">
      <div class="text-block ps-5">
      Welkom op mijn website!<br/>
      Ik ben Margot. Ik maak kunst die geïnspireerd is op emoties. Ik wil de magie van de felle kleuren - van helder rood tot het donkerste zwart - laten spreken in mijn werken. Felle kleuren maken mij vrolijk. Ik werk graag abstract, maar ik probeer verschillende stijlen uit. Mengen, prutsen, gieten, plakken, licht en donker, veel vlekken en vormen, kleine en grote vlakken ... het borrelt allemaal op uit mijn binnenste. Dat alles maakt mijn stijl nogal uniek.
      Ik hoop dat jullie er evenveel van genieten als ik.<br/>
      Groetjes,<br/>
      Margot
</div>
    </div>
    <div class="col-md-6">
      <div class="d-flex flex-column justify-content-center image-container">
        <div class="image-wrapper">
          <img src="../assets/margot-pic.jpg" class="center-pic">
          </div>
          </div>
    </div>
  </div>

  <imageLoader :small-image-url="banners[2].smallUrl" :big-image-url="banners[2].url" 
            class="banner my-5"> </imageLoader>

  <div id="expositie" class="row appearing-item">
    <div class="col-md-6">
      <div class="d-flex flex-column justify-content-center image-container">
        <div class="image-wrapper">
          <img src="../assets/perfect-vulnerability.png" class="center-pic">
          </div>
          </div>
    </div>
    <div class="col-md-1 d-flex justify-content-center align-self-center">
      <div class="text-block">
      Bedankt!
       </div>
    </div>
  </div>

  <imageLoader :small-image-url="banners[3].smallUrl" :big-image-url="banners[3].url" 
            class="banner my-5"> </imageLoader>
  <div class="d-flex flex-column align-items-center">
    <div class="image-wrapper bekijk-mijn-werk-img">
      <img id="painting" src="../assets/bekijk-werk.png" class="center-pic">
    </div>
    <b-button @click="$router.push('work')" class="margot-button">BEKIJK MIJN WERKEN</b-button>
  </div>

  <imageLoader :small-image-url="banners[4].smallUrl" :big-image-url="banners[4].url" 
            class="banner mt-5"> </imageLoader>
   
  </div>
</template>

<script>
import ImageLoader from './ImageLoader.vue';
import {Banner} from '../models/banner.ts';

export default {
  name: 'Home',
  components: {
      ImageLoader
  },
  data: () => {
    return {
    banners:  [
        new Banner('banner-1.png', 'banner-1-sm.png'),
        new Banner('banner-2.png', 'banner-2-sm.png'),
        new Banner('banner-3.png', 'banner-3-sm.png'),
        new Banner('banner-4.png', 'banner-4-sm.png'),
        new Banner('banner-5.png', 'banner-5-sm.png')
      ]
    };
  }
};
// import Vue from 'vue'
// import VueScrollmagic from 'vue-scrollmagic'


// Vue.use(VueScrollmagic, {
//   vertical: true,
//   globalSceneOptions: {},
//   loglevel: 2,
//   refreshInterval: 100
// })

// // init controller
// // var controller = new ScrollMagic.Controller();

// // create a scene
// this.$scrollmagic.Scene({
//     triggerElement: "#margot-title",
//     triggerHook: 0.9, // show, when scrolled 10% into view
//     duration: "80%", // hide 10% before exiting view (80% + 10% from bottom)
//     offset: 0 // move trigger to center of element
// })
// .setClassToggle("#margot-title", "visible") // add class to reveal
// .addIndicators() // add indicators (requires plugin)
// .addTo(controller);

// // create a scene
// new ScrollMagic.Scene({
//     triggerElement: "#expositie",
//     triggerHook: 0.9, // show, when scrolled 10% into view
//     duration: "80%", // hide 10% before exiting view (80% + 10% from bottom)
//     offset: 0 // move trigger to center of element
// })
// .setClassToggle("#expositie", "visible") // add class to reveal
// // .addIndicators() // add indicators (requires plugin)
// .addTo(controller);

// // create a scene
// new ScrollMagic.Scene({
//     triggerElement: "#about",
//     triggerHook: 0.9, // show, when scrolled 10% into view
//     duration: "80%", // hide 10% before exiting view (80% + 10% from bottom)
//     offset: 0 // move trigger to center of element
// })
// .setClassToggle("#about", "visible") // add class to reveal
// // .addIndicators() // add indicators (requires plugin)
// .addTo(controller);

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
body {
    font-family: 'Markazi Text', Arial, Helvetica, sans-serif !important;
    font-size: 21px !important;
    margin:0px;
}
.row {
  margin: 0;
}

.margot-block {
    margin-bottom: 2rem;
}

.margot-title {
    color: #FF4F4F;
    font-size: 4rem;
    font-family: 'Lekton';
}
.margot-subtext {
    color:darkgray;
}
.margot-image {
  width: 25%;
}
.margot-button {
      padding: 10px 20px;
}
.text-block {
    max-width: 350px;
}

.center-pic {
  width: 100%;
  padding: 2rem 15%;
}

.bekijk-mijn-werk-img {
  max-width:50rem;
}

.banner {
    width: 100%;
}

.copyright{
    position: absolute;
    bottom:10px;
    right: 10px;
    font-size: 11px;
    color: blue
}

.image-container{
  height:100%
}

/* because safari cannot handle it */
.image-wrapper {
  display:block; 
}
/* .appearing-item {
    opacity: 0;
    -webkit-transform: scale(0.9);
         -moz-transform: scale(0.9);
            -ms-transform: scale(0.9);
             -o-transform: scale(0.9);
                    transform: scale(0.9);
    -webkit-transition: all 1s ease-in-out;
         -moz-transition: all 1s ease-in-out;
            -ms-transition: all 1s ease-in-out;
             -o-transition: all 1s ease-in-out;
                    transition: all 1s ease-in-out;
}
.appearing-item.visible {
    opacity: 1;
    -webkit-transform: none;
         -moz-transform: none;
            -ms-transform: none;
             -o-transform: none;
                    transform: none;
} */

</style>
